import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import { PrismButton, PrismIcon } from '@mylighthouse/prism-ember';
// @ts-expect-error: Incorrect type
import stopPropagation from 'ember-event-helpers/helpers/stop-propagation';

interface HotelBudgetForecastTableLayoutSettingsDragItemSignature {
  Args: {
    isHidden: boolean;
    isPinnable: boolean;
    isPinned: boolean;
    label: string;
    toggleFixed: () => void;
    toggleVisible: () => void;
  };
  Element: HTMLLIElement;
}

const HotelBudgetForecastTableLayoutSettingsDragItem = <template>
  <li
    class="rounded-200 border-neutral-default bg-elevation-surface mb-200 flex items-center gap-200 border border-solid px-200 py-100 shadow-neutral-100"
    ...attributes
  >
    <PrismIcon @name="drag" @size="medium" />
    {{@label}}
    <PrismButton
      @buttonType="ghost"
      @icon={{unless @isHidden "visibility-on" "visibility-off"}}
      @size="small"
      class="ml-auto"
      {{on "click" (stopPropagation @toggleVisible)}}
    />
    {{#if @isPinnable}}
      <PrismButton
        @buttonType="ghost"
        @icon={{if @isPinned "pin" "unpin"}}
        @size="small"
        {{on "click" (stopPropagation @toggleFixed)}}
      />
    {{/if}}
  </li>
</template> satisfies TOC<HotelBudgetForecastTableLayoutSettingsDragItemSignature>;

export default HotelBudgetForecastTableLayoutSettingsDragItem;
